import { makeStyles } from '@material-ui/core/styles';

const FeatureCardStyles =
    makeStyles((theme) => ({
        featureCardContainer: {
            display: "flex",
            marginBottom: theme.spacing(8),
            overflow: "hidden",
            position: "relative",
            width: "100%",

            [theme.breakpoints.down("md")]: {
                display: "inline-block",
            },
        },
        featureCardContentContainer: {
            padding: "60px 50px 80px",
            position: "relative",
        },
        featureCardContentContainerImgSml: {
            width: "80%",
        },
        featureCardContentContainerImgMd: {
            width: "60%",
        },
        featureCardContentContainerImgLg: {
            width: "34%",
        },
        featureCardImgContainer: {
            verticalAlign: "middle",
            height: "100%",
            position: "absolute",
            right: 0,
            top: 0,
        },
        featureCardImgContainerSml: {
            width: "20%",
        },
        featureCardImgContainerMd: {
            width: "40%",
        },
        featureCardImgContainerLg: {
            width: "66%",
        },
        featureCardImg: {
            width: "100%",
            height: "100%",
            display: "flex",
        },
        title: {
            margin: `${theme.spacing(2)}px 0`,
        },
        content: {
            marginBottom: theme.spacing(4),
        },
        link: {
            position: "absolute",
            bottom: theme.spacing(4),
            left: theme.spacing(6),
        }
    }));

export default FeatureCardStyles;